import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'top',
        labels: { fontColor: '#000', fontSize: 11 }
      },
      tooltips: {
        mode: 'index',
        intersect: false
      },
      scales: {
        xAxes: [{
          ticks: { fontColor: '#000', fontSize: 9 }
        }],
        yAxes: [
          {
            id: 'y-sessoes',
            position: 'left',
            ticks: { fontColor: '#000', fontSize: 9, beginAtZero: true },
            scaleLabel: { display: true, labelString: 'Sessões' }
          },
          {
            id: 'y-ativos',
            position: 'right',
            gridLines: { drawOnChartArea: false },
            ticks: { fontColor: '#000', fontSize: 9, beginAtZero: true },
            scaleLabel: { display: true, labelString: 'Usuários ativos' }
          }
        ]
      }
    }
  }),
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}

